<template>
  <el-dialog
    :visible.sync="showDialog"
    custom-class="card"
    @open="doOpen"
    @closed="doClosed"
    append-to-body
  >
    <template v-if="showContent">
      <div class="icon-lock">
        <img src="./../../../assets/images/img-lock.png" alt>
      </div>
      <div class="dialog-title">
        <h5>修改密码</h5>
        <p>修改成功后新的密码将在下次登录时生效</p>
      </div>
      <el-form :model="formData" :rules="formRule" ref="passForm" class="dialog-form">
        <div>
          <el-form-item class="pr" prop="pass">
            <el-input
              v-model="formData.pass"
              placeholder="新密码"
              maxlength="16"
              :type="showPass ? 'text' : 'password'"
            ></el-input>
            <div class="btn-show" @click="showPass=!showPass">
              <i class="el-icon-view"></i>
            </div>
          </el-form-item>
          <el-form-item prop="check">
            <el-input v-model="formData.check" placeholder="确认密码" type="password" maxlength="16"></el-input>
          </el-form-item>
        </div>
        <div class="gap mt-10"></div>
        <p>密码须8-16位数字、字母与符号的组合</p>
      </el-form>

      <div class="btn-box">
        <button class="btn btn-cancel" @click="showDialog = false;">取消</button>
        <button class="btn btn-save" @click="handleUpdate">确定</button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import aes from "@/uitls/aes";

export default {
  components: {},
  computed: {
    ...mapState(["userInfo", "unlockData"]),
    // dialog show/hide
    showDialog: {
      // getter
      get: function() {
        return this.visible;
      },
      // setter
      set: function(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    // password regulation
    const passR = (rule, value, callback) => {
      let reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,16}$/;
      if (value !== "") {
        if (!reg.test(value)) {
          callback(new Error("密码过于简单"));
        } else {
          callback();
        }
      } else {
        callback(new Error("密码不能为空"));
      }
    };
    // repeat password rule
    const checkR = (rule, value, callback) => {
      if (value != this.formData.pass) {
        callback(new Error("两次密码不一致"));
      } else if (value == "") {
        callback(new Error("密码不能为空"));
      } else {
        callback();
      }
    };
    return {
      formData: {
        pass: "",
        check: ""
      },
      // test flight - showContent: false
      showContent: true,
      showPass: false,
      formRule: {
        pass: [{ validator: passR, trigger: "blur" }],
        check: [{ validator: checkR, trigger: "blur" }]
      },
    };
  },
  methods: {
    doClosed() {
      this.showContent = false;
    },
    doOpen() {
      this.showContent = true;
      this.formData.pass = "";
      this.formData.check = "";
    },
    // update pass by {unlock code, unlock phone}, {new password}
    handleUpdate() {
      this.$refs.passForm.validate(valid => {
        if (valid) {
          this.$http.post("/user-server/setting/reset/password", {
            unlockCode: this.unlockData.code,
            unlockPhone: this.userInfo.phoneNo,
            newPassword: aes.Encrypt(this.formData.pass)
          })
          .then(res => {
            if (res.data.code == 200) {
              this.doUpdate();
            }
            this.$eventHub.$emit('sendUpdate', res)

          })
          .catch(err => {
            console.log("ERROR", err);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      })
      
    },
    doUpdate() {
      // this.$emit("update");
      this.showDialog = false;
    }
  },
  watch: {},
  mounted: function() {}
};
</script>

<style lang="scss" scoped>
@import "../styles/card.scss";
.dialog-form {
  .btn-show {
    position: absolute;
    width: 20px;
    height: 20px;
    line-height: 20px;
    right: 0px;
    top: 10px;
  }
}
</style>
<style lang="scss">
/* overwrite el-dialog */
.card {
  &.el-dialog {
    width: 440px;
    border-radius: 6px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 20px;
  }
  .el-form-item {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userInfo/components/cardP.vue